import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "AppKeys"*/ "./lazyIndex"), {
    name: "AppKeys",
});
export const lazySetupAppModuleKeys: LazyAction<typeof lazyIndex.setupAppModuleKeys, typeof lazyModule> = new LazyAction(lazyModule, m => m.setupAppModuleKeys);
